import React from 'react';
import { useCallback, useState } from 'react'
import burger_2 from '../../static/img/burger-2.png'
import close from "../../static/img/close.svg"
import { sendForgetPassword, sendLogin } from './loginApi'
import { useDispatch, useSelector } from 'react-redux'
import { selectCalcPage, setCalcPage, setIsLogin, setUserEmail } from '../home/homeSlice'
import { useNavigate } from 'react-router-dom';
import { MAIN_ROUTE } from '../../static/vars';

export function Login() {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [emailLogin, setEmailLogin] = useState('')
    const [password, setPassword] = useState('')
    const [user, setUser] = useState('')
    const [showFormForgetPassword, setShowFormForgetPassword] = useState(false)
    const [statusResMessage, setStatusResMessage] = useState('')

    const calcPage = useSelector(selectCalcPage)

    const handleChangePassword = (e) => {
        setPassword(e.target.value)
        // setUser(e.target.value)
    }

    const handleChangeUsername = (e) => {
        setEmailLogin(e.target.value)
    }

    const handleCloseLogin = () => {
        // dispatch(setCalcPage('calc'))
        navigate(MAIN_ROUTE + '/personal', { replace: true })
    }

    const handleLogin = () => {
        // window.ym(90426649,'reachGoal','voyty1') 
        sendLogin({ email: emailLogin, password: password },
            (data) => {
                console.log(emailLogin, 'password')
                if (data.res) {
                    dispatch(setIsLogin(true))
                    // props.setUserId(data.user_id)
                    // props.setIsCustomer(data.customer)

                    dispatch(setUserEmail(emailLogin))
                    handleCloseLogin()
                }
                else {
                    alert('Ошибка авторизации')
                }
            }
        )
    }

    const handleForget = () => {
        setShowFormForgetPassword(true)
    }

    const handleSendPassword = () => {
        console.log('handleSendPassword')
        sendForgetPassword({ email: emailLogin }, function (data) {
            console.log('sendForgetPassword', data)
            if (data) {
                setStatusResMessage('Пароль отправлен')
            }
            else {
                setStatusResMessage('Неверная почта')
            }
        }
        )
    }

    return (
        <>

            <div class="b-popup" id="popup2">
                <div class="b-popup-vnutr"></div>
                <div class="b-popup-content b-popup-content-2" style={{ marginTop: '20vh' }}>
                    <p class="popup-title popup-title-2">Авторизация</p>
                    <form class="form-popup">
                        <div class="one-ryad one-ryad-popup one-ryad-popup-1 one-ryad-popup-user one-ryad-popup-user-1">
                            <label for="select-1">E-mail</label>
                            <input
                                value={emailLogin} onChange={handleChangeUsername}
                                class="pole-popup pole-popup-user pole-popup-1" name="E-mail" type="email" placeholder="|"
                                required />
                        </div>
                        {!showFormForgetPassword &&
                            <>
                                <div class="one-ryad one-ryad-popup one-ryad-popup-1 one-ryad-popup-user one-ryad-popup-user-2">
                                    <label for="select-1">Пароль</label>
                                    <input
                                        value={password} onChange={handleChangePassword}
                                        class="pole-popup pole-popup-user pole-popup-1" name="E-mail" type="email"
                                        placeholder="*********" required />
                                </div>
                                <button onClick={handleLogin} class="button button-1 button-popup-1">Войти</button>
                                <div onClick={handleForget} class="popup2-link">Не помню пароль</div>
                            </>
                        }

                        {
                            showFormForgetPassword &&
                            <>
                                <div onClick={handleSendPassword}  class="button button-1 button-popup-1">Восстановить</div>
                                <div class="popup2-link">{statusResMessage}</div>
                            </>
                        }


                    </form>
                    <div onClick={handleCloseLogin} class="popup-close">
                        <img src={close} alt="close" />
                    </div>
                </div>
            </div>

        </>
    )
}